import { action, observable, flow, makeObservable, override } from 'mobx';
import { ApiResponse, GlobalStore, GridStore } from '@roc/feature-app-core';
import { CounterPartyExpensesTab } from '../types/types';
import { SpecialServicingBaseStore } from './specialServicingBaseStore';
import { PayablesApprovedStore } from './payablesApprovedStore';
import { FileUpload } from '@roc/ui';
import { downloadDocument } from '@roc/feature-utils';

export class RefundsDashboardStore extends SpecialServicingBaseStore {
  payablesApprovedStore: PayablesApprovedStore;
  constructor(globalStore: GlobalStore) {
    super(globalStore);
    this.tab = CounterPartyExpensesTab.PENDING_REFUNDS;
    this.payablesApprovedStore = new PayablesApprovedStore(globalStore);
    makeObservable(this, {
      fetchEntityNames: flow,
      uploadRefundsFile: flow,
      downloadRefundsReport: flow,
      setRecordsId: override,
      removeRecordsId: override,
      clearRecordsIds: override,
    });
  };

  *fetchEntityNames() {
    try {
      const response: ApiResponse = yield this.service.getRefundEntities();
      this.entityList = response.data.data.map(value => (
        { label: value.vendorName, value: value.companyId }
      ));
    }
    catch (error) {
      console.log("error", error)
      this.globalStore.notificationStore.showErrorNotification({
        message: 'Error while fetching vendor names.',
      });
    }
  };

  reset() {
    this.tab = CounterPartyExpensesTab.PENDING_REFUNDS;
    this.counterPartyExpenseGridStore.reset();
    this.recordsIds = [];
  };

  performActions(status: string) {
    throw Error('Not Implemented!');
  }

  performAction(id: number, status: string) {
    throw Error('Not Implemented!');
  }

  *uploadRefundsFile(fileUpload: FileUpload) {
    try {
      var newFile;
      if (fileUpload) {
        const file = fileUpload.file;
        const blob = file.slice(0, file.size, file.type);
        newFile = new File([blob], fileUpload.name, { type: file.type });
      }
      yield this.service.uploadRefundsFile(
        this.entity,
        newFile
      );
      this.globalStore.notificationStore.showSuccessNotification({
        message: 'Refunds file uploaded successfully.',
      });
    } catch (error) {
      this.globalStore.notificationStore.showErrorNotification({
        message: 'Error while uploading refunds file.',
      });
    }
  };


  *downloadRefundsReport() {
    try {
      const response = yield this.service.downloadRefundsReport(this.recordsIds);
      downloadDocument(response.data, response.headers, 'download', `PENDING_REFUNDS_REPORT.xlsx`);
      this.globalStore.notificationStore.showSuccessNotification({
        message: 'Refunds report downloaded successfully.'
      });
    } catch (error) {
      this.globalStore.notificationStore.showErrorNotification({
        message: 'Error while downloading refunds report.',
      });
    }
  }

  setRecordsId = (id, selected) => {
    super.setRecordsId(id, selected);
    this.payablesApprovedStore.setRecordsId(id, selected);
  }

  clearRecordsIds = () => {
    super.clearRecordsIds();
    this.payablesApprovedStore.clearRecordsIds();
  }

  removeRecordsId(id) {
    super.removeRecordsId(id);
    this.payablesApprovedStore.removeRecordsId(id);
  }

}
